import {useDispatch, useSelector} from 'react-redux';


import cartService from '../../../../services/CartService';

import {cartActions, cartSelectors} from '../index';

import useIsCartLoaded from './useIsCartLoaded';


/**
 * Loads the given cart
 *
 * @param cartId {string} Cart id to load
 * @return {object} Cart or null if not loaded
 */
function useCart(cartId) {

    const isCartLoaded = useIsCartLoaded(cartId);
    const cart = useSelector(state => cartSelectors.getCart(state, cartId));
    const dispatch = useDispatch();

    if (isCartLoaded) {

        return cart;
    }

    (async () => {

        const loadedCart = await cartService.getCart(cartId);
        dispatch(cartActions.onCartLoaded(loadedCart));
    })();

    return cart;
}


export default useCart;
